// File: frontend/src/pages/HomePage.js
// This file is now just a container.
// It imports the new GeneratorTool and tells it to be the "default" type.

import React from 'react';
import GeneratorTool from '../components/GeneratorTool';

// --- ★ MODIFICATION: Accept 'onJobStarted' prop ---
function HomePage({ session, onJobStarted }) {
  // All the logic is now inside GeneratorTool.
  // We just render it here and pass down the session, toolType, and the new prop.
  return (
    <GeneratorTool 
      session={session} 
      toolType="default" 
      onJobStarted={onJobStarted} // <-- Pass it down
    />
  );
}

export default HomePage;